import React from 'react';
import PropTypes from 'prop-types';

var PercentageBar = function PercentageBar(props) {
  return React.createElement("span", {
    className: "percentage-bar"
  }, React.createElement("span", {
    className: "portion" // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
    ,
    style: {
      width: "".concat(props.portion / props.total * 100, "%")
    }
  }));
};

PercentageBar.displayName = 'Percentage Bar';
PercentageBar.propTypes = {
  total: PropTypes.number,
  portion: PropTypes.number
};
export default PercentageBar;